import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Check } from "./../../Assets/Icons/Check";
import { genericFetchData } from "../../Services/Service";
import "./../../Components/Details.jsx/Journey.css";

const Journy = ({ tileId, dataType }) => {
  const [taskStage, setTaskStage] = useState([]);

  const fetchTaskStage = async () => {
    try {
      const response = await genericFetchData(
        `/myspace/task/stages?dataType=${dataType}&typeId=${tileId}`
      );
      const { status } = response;
      if (status === 200) {
        const responseData = await response.json();
        return responseData;
      } else {
        throw new Error(
          `Failed to fetch task stages. Status: ${response.status}`
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const getTaskStage = async () => {
    try {
      const taskStageData = await fetchTaskStage();
      const taskStages = taskStageData.taskStages;
      setTaskStage(taskStages);
    } catch (error) {
      console.log(error);
    }
  };

  const [progress, setProgress] = useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        const newProgress = oldProgress + 20;
        if (newProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return newProgress;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const allApproved = taskStage?.every((item) => item.status === "APPROVED");

  useEffect(() => {
    if (tileId) {
      getTaskStage();
    }
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case "PROCESSING":
        return "#DC8E1F";
      case "APPROVED":
        return "#17DFBA";
      case "REJECTED":
        return "#F66C61";
      default:
        return "grey";
    }
  };
  return (
    <>
      {taskStage?.length > 0 && (
        <Box
          sx={{
            backgroundColor: "#EBF1F3",
            height: "100px",
            margin: "25px  0px",
            borderRadius: "20px",
            display: "flex",
            justifyContent: "space-around",
            paddingTop: "35px",
          }}
        >
          <Box
            width={"80%"}
            height={"10px"}
            bgcolor={"#DCE8EC"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
            position={"relative"}
            sx={{
              cursor: "pointer",
            }}
          >
            {taskStage?.map((data) => {
              return (
                <Box position={"relative"} zIndex={50}>
                  <Box
                    width={"34px"}
                    height={"34px"}
                    borderRadius={50}
                    bgcolor={"#DCE8EC"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{ border:allApproved? "1px solid #17dfba":"none" }}
                  >
                    <Check color={getStatusColor(data?.status)} />
                  </Box>
                  <Typography
                    fontSize={"11px"}
                    fontWeight={600}
                    position={"absolute"}
                    width={"100px"}
                    textAlign={"center"}
                    left={"-30px"}
                    color={getStatusColor(data?.status)}
                  >
                    {data?.departmentType} {data?.status}
                  </Typography>
                </Box>
              );
            })}
            <Typography
              position={"absolute"}
              left={"8%"}
              bottom={"10px"}
              zIndex={60}
              fontSize={"11px"}
              color={"#2E2E2E"}
            >
            </Typography>
            <Grid
              className="progress-bar"
              sx={{
                width: allApproved ? `${progress}%` : "100%",
                bgcolor: allApproved ? "#17dfba" : "#dce8ec",
              }}
              height={"10px"}
              position={"absolute"}
              borderRadius={10}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default Journy;
